import { render, staticRenderFns } from "./MessageLogin.vue?vue&type=template&id=0a91f04d&scoped=true&"
import script from "./MessageLogin.vue?vue&type=script&lang=js&"
export * from "./MessageLogin.vue?vue&type=script&lang=js&"
import style0 from "./MessageLogin.vue?vue&type=style&index=0&id=0a91f04d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a91f04d",
  null
  
)

export default component.exports